/* istanbul ignore file */

import { Injectable } from '@angular/core';

import { Logger } from './logger.service';

@Injectable()
export class MockLoggerService implements Logger {
  public dispatchedActions = ['Action1', 'Action2'];

  public debug = () => null;

  public log = () => null;

  public info = () => null;

  public warn = () => null;

  public error = () => null;
}
